import { useState } from "react";
import { Sparkles, Send, Loader2 } from "lucide-react";
import api from "../lib/api";

const SUGGESTIONS = [
  "What do I need to handle today?",
  "Which jobs are over budget?",
  "Which invoices are overdue?",
  "Which bid should I focus on first?",
];

export function AIBar() {
  const [q, setQ] = useState("");
  const [answer, setAnswer] = useState(null);
  const [loading, setLoading] = useState(false);

  const ask = async (question) => {
    const query = question || q;
    if (!query.trim()) return;
    setQ(query);
    setLoading(true);
    setAnswer(null);
    try {
      const { data } = await api.post("/ai/ask", { question: query });
      setAnswer(data.answer);
    } catch (e) {
      setAnswer("Hardwire AI is unavailable right now. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="hw-card hw-glow p-5 md:p-6 hw-rise" data-testid="ai-bar">
      <div className="flex items-center gap-2 mb-4">
        <div className="flex h-8 w-8 items-center justify-center rounded-lg bg-cyan-500/15 border border-cyan-500/40">
          <Sparkles size={16} className="text-cyan-300" />
        </div>
        <div>
          <div className="font-head text-lg font-bold text-white leading-none">Hardwire AI</div>
          <div className="hw-eyebrow mt-1">Your executive assistant</div>
        </div>
      </div>

      <form
        onSubmit={(e) => {
          e.preventDefault();
          ask();
        }}
        className="flex gap-2"
      >
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Ask anything about your business…"
          className="hw-input flex-1"
          data-testid="ai-input"
        />
        <button
          type="submit"
          disabled={loading}
          className="flex items-center gap-2 rounded-xl bg-cyan-500 px-5 font-semibold text-slate-900 transition hover:bg-cyan-400 disabled:opacity-50"
          data-testid="ai-ask-btn"
        >
          {loading ? <Loader2 className="animate-spin" size={18} /> : <Send size={18} />}
          <span className="hidden sm:inline">Ask</span>
        </button>
      </form>

      <div className="mt-3 flex flex-wrap gap-2">
        {SUGGESTIONS.map((s) => (
          <button
            key={s}
            onClick={() => ask(s)}
            className="rounded-full border border-slate-700 bg-slate-800/50 px-3 py-1 text-xs text-slate-300 transition hover:border-cyan-500/40 hover:text-cyan-300"
            data-testid={`ai-suggestion-${s.slice(0, 10).replace(/\s/g, "-").toLowerCase()}`}
          >
            {s}
          </button>
        ))}
      </div>

      {(loading || answer) && (
        <div className="mt-4 rounded-xl border border-cyan-500/20 bg-slate-950/60 p-4" data-testid="ai-answer">
          {loading ? (
            <div className="flex items-center gap-2 text-slate-400">
              <Loader2 className="animate-spin text-cyan-400" size={16} /> Analyzing live operational data…
            </div>
          ) : (
            <div className="whitespace-pre-wrap text-sm leading-relaxed text-slate-200">{answer}</div>
          )}
        </div>
      )}
    </div>
  );
}
